import { useState } from 'react';

import useFocusOnMount from '../../../hooks/useFocusOnMount';
import { getBuildNumber, getSandbox } from '../../../services/browser';
import { setSettingsItems } from '../../../services/windowMessaging';
import { Modal } from '../../Modal';

import { StyledField, StyledTextInput } from './styles';

export type SettingsModalProps = {
  onClose: () => void;
  isOpen: boolean;
};

export const SettingsModal = ({ onClose, isOpen }: SettingsModalProps) => {
  const [uiVersion, setUiVersion] = useState(getBuildNumber);
  const [sandbox, setSandbox] = useState(getSandbox);

  const inputRef = useFocusOnMount([isOpen]);

  const onApplySettings = () => {
    if (uiVersion !== getBuildNumber()) {
      setSettingsItems({ isCustomUiVersion: true });
    }
    setSettingsItems({ uiVersion });
    window.parent.postMessage({ message: 'set sandbox', sandbox }, '*');
  };

  const onResetSettings = () => {
    setSettingsItems({
      isCustomUiVersion: false,
      uiVersion: null,
    });
    window.parent.postMessage({ message: 'reset uiversion' }, '*');
    window.parent.postMessage({ message: 'set sandbox', sandbox: 'production' }, '*');
  };

  const handleCloseFinish = () => {
    setUiVersion(getBuildNumber);
    setSandbox(getSandbox);
  };

  return (
    <Modal
      heading="Settings"
      onClose={onClose}
      cancelButtonProps={{
        'data-automation': 'CancelButton',
        onClick: onResetSettings as () => void,
        children: 'Reset',
        variant: 'flat',
      }}
      confirmButtonProps={{
        'data-automation': 'ConfirmButton',
        onClick: onApplySettings as () => void,
        children: 'Apply',
      }}
      isOpen={isOpen}
      onCloseFinish={handleCloseFinish}
    >
      <StyledField>
        <span>UI version</span>
        <StyledTextInput
          data-automation="UiVersion"
          type="text"
          value={uiVersion}
          onChange={(e) => setUiVersion(e.target.value)}
          ref={inputRef}
        />
      </StyledField>
      <StyledField>
        <span>Sandbox</span>
        <StyledTextInput
          data-automation="Sandbox"
          type="text"
          value={sandbox}
          onChange={(e) => setSandbox(e.target.value)}
        />
      </StyledField>
    </Modal>
  );
};
